import React, { useState, useEffect } from 'react'
import Root from 'pages/Root'
import Footer from 'organisms/Footer'
import client from 'api/prismicClient'
import Container from 'atoms/layout/Container'
import Header from 'organisms/Header'
import SimpleRichContents from 'organisms/SimpleRichContents'

export default function English () {
  const [doc, setDoc] = useState<any>(null)
  useEffect(() => {
    (async () => {
      const response = await client.getSingle('english', {})
      setDoc(response)
    })()
  })

  return (
    <Root>
      <Header/>
      <Container>
        <SimpleRichContents
          content={doc?.data.contents}
          title="English"
          noEyeCatching
        />
      </Container>
      <Footer/>
    </Root>
  )
}
